import { of, Observable } from 'rxjs';

import { UploaderService } from '@app/uploader/uploader.service';
import { UploadAdapter } from '../upload-adapter';
import { FileUploadSetting } from '@app/uploader/uploader-api.model';
import { UploadEvent } from '@app/uploader/uploader';

export class DefaultFileUploadAdapter extends UploadAdapter {
  constructor(
    uploaderService: UploaderService,
    private uploadApiEndpoint: string,
    private maxSizeMB: number,
    private allowedFileTypes: string[]
  ) {
    super(uploaderService);
  }

  public getUploadSettings(): Observable<FileUploadSetting> {
    return of({
      maxSizeMB: this.maxSizeMB,
      allowedFileTypes: this.allowedFileTypes,
    });
  }

  public upload(file: File, _?: never): Observable<UploadEvent> {
    const formData: FormData = this.uploaderService.prepRawFile(file as any);
    return this.uploaderService.uploadFile(
      formData,
      this.uploadApiEndpoint,
      {},
      undefined,
      true
    );
  }
}
